// Reviewer preference: show the Footprint lab group in the sidebar (default on). Kept per browser.
import { useSyncExternalStore } from 'react';

const KEY = 'wt.showLab';
const ls = new Set<() => void>();
const read = () => { try { return localStorage.getItem(KEY) !== '0'; } catch { return true; } };
export const setShowLab = (on: boolean) => {
  try { localStorage.setItem(KEY, on ? '1' : '0'); } catch { /* storage blocked: keep the session default */ }
  ls.forEach((l) => l());
};
export const useShowLab = () => useSyncExternalStore((l) => { ls.add(l); return () => { ls.delete(l); }; }, read, () => true);
